import { SET_USER_DATA } from '../actions';

const initialState = {
  userData: null,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return {
        ...state,
        userData: action.payload.userData
      };
    default:
      return state;
  }
};

export default login;